import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WhatsappImageComponent } from './whatsapp-image.component';

const routes: Routes = [{ path: '', component: WhatsappImageComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WhatsappImageRoutingModule { }
